import { Store } from 'redux';
import { setCameraAndTime, setRequestedView } from 'actions/appActions';
import { parseCameraAndTimeUrl } from 'logic/parseCameraAndTimeUrl';

export const processSpecialRoutes = (queryString: string, store: Store<{}>) => {
    // Did the user come from an Alarm Email? (See Seer.Web.Alarm)
    const cameraAndTime = parseCameraAndTimeUrl(queryString);
    if (cameraAndTime) {
        store.dispatch(setCameraAndTime(cameraAndTime));
    }

    // Did the user come from ServerConfig to jump directly into a video view with specific cameras?
    const match = /\?view=(.+)&/.exec(queryString);
    if (match) {
        const deviceIndexes = match[1].split(',').map(s => parseInt(s, 10));
        store.dispatch(setRequestedView(deviceIndexes));
    }
};



// WEBPACK FOOTER //
// ./src/startup/processSpecialRoutes.ts